/**
 * Replaces the whitespace characters in a string. By default it removes them.
 * @function
 * @param {string} text - Original text
 * @param {boolean} multi - Replaces all whitespace characters in continuous sequences or one by one
 * @param {string} replaceWith - Character(s) replacing the whitespaces
 * @returns {string} - New string with the whitespace characters replaced
 */
export const replaceWhitespace = (
  text: string,
  replaceWith: string = '',
  multi: boolean = false,
): string => (multi ? text.replace(/\s+/g, replaceWith) : text.replace(/\s/g, replaceWith));
